import * as React from 'react';
import { css, CSSObject, Global } from '@emotion/react';
import { useHoneycombTheme } from '../../hooks';
import { createResponsiveStyles } from '../../utils';
import { SERIALIZED_STATIC_STYLES } from './GlobalStyles.static';
import { getVariantFamilyStyles, getGutterStyles, getContentMarginStyles } from './GlobalStyles.utils';

export function GlobalStyles(): React.JSX.Element {
    const { theme } = useHoneycombTheme();
    const { breakpoints } = theme;
    const { gutters, contentMargins } = breakpoints;

    const dynamicStyles: CSSObject = {
        // Prepare CSS variables for the different typography size variants
        ...getVariantFamilyStyles('body', theme),
        ...getVariantFamilyStyles('caption', theme),
        ...getVariantFamilyStyles('heading', theme),
        ...getVariantFamilyStyles('hero', theme),
        ...getVariantFamilyStyles('price', theme),

        '[data-default-gutters]': {
            ...createResponsiveStyles(
                [
                    {
                        value: gutters,
                        getStyles: getGutterStyles(theme),
                    },
                ],
                theme
            ),
        },

        '[data-content-margins]': {
            ...createResponsiveStyles(
                [
                    {
                        value: contentMargins,
                        getStyles: getContentMarginStyles(),
                    },
                ],
                theme
            ),
        },
    };

    return <Global styles={[SERIALIZED_STATIC_STYLES, css(dynamicStyles)]} />;
}
